import { formatDuration, intervalToDuration } from "date-fns"

const convertToHours = (duration: Duration): Duration => {
  const updatedDuration = { ...duration }

  if (updatedDuration.days) {
    updatedDuration.hours += duration.days * 24
    updatedDuration.days = 0
  }
  if (updatedDuration.weeks) {
    updatedDuration.hours += updatedDuration.weeks * 7 * 24
    updatedDuration.weeks = 0
  }
  if (updatedDuration.months) {
    updatedDuration.hours += updatedDuration.months * 30 * 24
    updatedDuration.months = 0
  }
  if (updatedDuration.years) {
    updatedDuration.hours += updatedDuration.years * 365 * 24
    updatedDuration.years = 0
  }

  return updatedDuration
}

const formatDistanceLocale = {
  xSeconds: "{{count}}s",
  xMinutes: "{{count}}m",
  xHours: "{{count}}h"
}
const shortEnLocale = {
  formatDistance: (token, count) =>
    formatDistanceLocale[token].replace("{{count}}", count)
}

export const durationFormatter = {
  format: (seconds: number, narrow?: boolean) => {
    return formatDuration(
      convertToHours(intervalToDuration({ start: 0, end: seconds * 1000 })),
      {
        ...(!seconds || seconds < 3600
          ? { format: ["minutes"], zero: true }
          : { format: ["hours", "minutes"], zero: false }),
        locale: narrow ? shortEnLocale : undefined
      }
    )
  }
}
